import {Component, OnInit} from '@angular/core';
import {AccountService} from '../../services/account.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {saveAs} from 'file-saver';
import { AlertService } from '../../shared/services/alert.service';
import { ApplicationService } from '../../shared/services/application.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as Constants from '../../models/Constants';
import { CommonService } from '../../shared/services/common.service';
import { ErrorHandlerService } from '../../services/error-handler.service';

@Component({
  selector: 'app-file-preview',
  templateUrl: './file-preview.component.html',
  styleUrls: ['./file-preview.component.css']
})
export class FilePreviewComponent implements OnInit {

  header: any;
  pdfSrc: any;
  inputUrl: string;
  title: string;
  file:any;
  showDownloadButton = false;
  isUserDirector = false;
  isDocumentCertificate = false;
  comment : string;
  showComment = false;
  appID:number;
  actionName:string;


  constructor(private accService: AccountService, public modalRef: BsModalRef,private alertService: AlertService,
    private applicationService: ApplicationService,private spinner: NgxSpinnerService,private commonService:CommonService,
    private errorHandlerService: ErrorHandlerService) {

  }

  ngOnInit() {
    if (typeof (FileReader) !== 'undefined' && this.file) {
      let reader = new FileReader();

      reader.onload = (e: any) => {
        this.pdfSrc = e.target.result;
      };

      reader.readAsArrayBuffer(this.file);
    }
    else {
      this.commonService.fetchDocument(this.inputUrl).subscribe(data => {
        const blob = new Blob([data], {
          type: 'application/pdf'
        });
        this.file = blob;
        if (typeof (FileReader) !== 'undefined' && this.file) {
          let reader = new FileReader();
    
          reader.onload = (e: any) => {
            this.pdfSrc = e.target.result;
          };  
          reader.readAsArrayBuffer(this.file);
        }
      });     
    }
}

  downloadDocument(){
    const name = this.title ?? 'Certificate.pdf'; 
    const blob = new Blob([this.file], {
      type: 'application/pdf'
    });
    saveAs(blob, name);
  }

  printDocument(){
    const blob = new Blob([this.file], {
      type: 'application/pdf'
    });
    const blobUrl = window.URL.createObjectURL(blob);
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = blobUrl;
    document.body.appendChild(iframe);
    iframe.contentWindow.print();
    iframe.contentWindow.onafterprint = function(event) { 
      console.log("Printed");
     };
  }

  downloadClicked(){
    if(this.isDocumentCertificate && this.isUserDirector){
      this.actionName = Constants.CERTIFICATE_DOWNLOADED_NAME;
      this.showComment = true;
    }
    else{
      this.downloadDocument();
    }
  }

  printClicked(){
    if(this.isDocumentCertificate && this.isUserDirector){
      this.actionName = Constants.CERTIFICATE_PRINTED_NAME;
      this.showComment = true;
    }
    else{
      this.printDocument();
    }
  }

  submitComment(comment) {
    this.spinner.show();
    const data = {
      'applicationID': this.appID,
      'statusCode': this.actionName,
      'comment': comment.value
    };
    // send api
    this.applicationService.changeApplicationStatus(data).subscribe(
      response => {
        this.spinner.hide();
        this.showComment = false;
        if (response) {
          if(this.actionName === Constants.CERTIFICATE_PRINTED_NAME){
            this.alertService.success('Print Comment Submitted Successfully');
            this.printDocument();
          }
          else if(this.actionName === Constants.CERTIFICATE_DOWNLOADED_NAME){
            this.alertService.success('Download Comment Submitted Successfully');
            this.downloadDocument();
          }
        } else {
          this.alertService.error('Comment Submit Failed');
        }
      }, err => {
        this.spinner.hide();
        this.showComment = false;
        this.modalRef.hide();
        this.alertService.error(this.errorHandlerService.handleApiError(err));
      });
  }
    
}

